import { render, staticRenderFns } from "./Dashboardkpis.vue?vue&type=template&id=4dc43132"
import script from "./Dashboardkpis.vue?vue&type=script&lang=js"
export * from "./Dashboardkpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports